/**
 * Created by hao.cheng on 2017/5/7.
 */
import React from 'react';
import CkPage from "../../components/CkPage";
import styled from "styled-components";
import {Button} from "antd";
import Iconfont from "../../components/Iconfont/Iconfont";



class RewardGuidePage extends React.Component {
    state = {
        animated: ''
    };

    render() {
        const ckPageContent = <div style={{backgroundColor:'#fff',padding:16}}>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#EC6A59'}}  libname="ckicon" type="shuzisucai3"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>该服务需要高级会员权限，请去</span>
                    <Button  type="primary" ghost  onClick={()=>{
                    this.props.router.push("/admin/mall/products");
                }}>商城购买</Button>
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/wall-bg1.jpg" alt=""/>
            </div>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#9CBC23'}}  libname="ckicon" type="shuzisucai4"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>现场打赏—现场直接为喜欢的节目或嘉宾打赏红包，活动赞不赞，您说了算！</span>
                    {/*<Button  type="primary" ghost  onClick={()=>{*/}
                        {/*window.open('https://www.bilibili.com/video/av23853599')*/}
                    {/*}}>视频演示</Button>*/}
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/reward_bg.jpg" alt=""/>
            </div>
        </div>

        return (
            <CkPage title={null} content={ckPageContent}/>
        )
    }
}

export default RewardGuidePage;


// WEBPACK FOOTER //
// ./src/containers/reward/RewardGuidePage.jsx